import { render, staticRenderFns } from "./ForumChatThreadCardFooter.vue?vue&type=template&id=6771043e&scoped=true"
import script from "./ForumChatThreadCardFooter.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardFooter.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardFooter.vue?vue&type=style&index=0&id=6771043e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771043e",
  null
  
)

export default component.exports